import Table from "../../../component/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchMezzi } from '../../../features/Mezzi/mezziThunk'
import { fetchCompanies } from "../../../features/company/companyThunk";
// import tableData from "../../../utils/logistica/mezziLogisticaData.json";
const MezziLogistica = () => {
  const dispatch = useDispatch(); // Dispatch hook
  const mezzi = useSelector((state) => state.mezzi?.mezzi);
  const loading = useSelector((state) => state.mezzi?.loading); // You might want to track loading status too
  const columns = [
    { field: "name", headerName: "Nome del mezzo", width: 1058 },
    { field: "tipo_mezzo", headerName: "Tipologia mezzo", width: 165 },
    { field: "targa", headerName: "Targa", width: 119 },
    { field: "status", headerName: "Stato Documenti", width: 165 },
    { field: "anno_acquisto", headerName: "Anno di acquisto", width: 177 },
    { field: "azioni", headerName: "Azioni", width: 60, sortable: false },
  ];
  const [tableRows, setTableRows] = useState([]);
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  useEffect(() => {
    dispatch(fetchCompanies())
  }, [dispatch])
  useEffect(() => {
    dispatch(fetchMezzi()); // Dispatch the fetchProdotti action to get the data
  }, [dispatch, selectSelectedCompany]);
  useEffect(() => {
    // if (mezzi && mezzi.length > 0) {
      console.log(mezzi);
      const mappedData = mezzi.map((item) => ({
        id: item?.id,
        name: item?.name,
        tipo_mezzo: item?.tipo_mezzo,
        targa: item?.targa,
        anno_acquisto: item?.anno_acquisto,
        volume: item?.volume,
        total_km: item?.total_km,
        status: item?.status
        // codEan: item.ean_code,
        // denominazione: item.denominazione?.toUpperCase(),
      }));
      setTableRows(mappedData);
    // }
  }, [mezzi]);
  return (
    <div className="pageTemplate">
      {loading ? (
        <div>Loading...</div> // You can show a loading spinner or message while fetching data
      ) : (
        <Table
          data={tableRows}
          columns={columns}
          navData={"structureMezzi"}
          deleteFunctions={"deleteMezziData"}
        />
      )}
    </div>
  );
};
export default MezziLogistica;